import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  loading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
}

export default function Button({
  variant = 'primary',
  loading = false,
  loadingText,
  children,
  disabled,
  className = '',
  type = 'button',
  ...props
}: ButtonProps) {
  const { t } = useTranslation();
  const isDisabled = disabled || loading;

  const base =
    'w-full py-3 px-4 text-[15px] font-semibold rounded-[10px] flex items-center justify-center gap-2.5 transition-colors duration-150 select-none';

  const variantClasses: Record<string, string> = {
    primary: isDisabled
      ? 'bg-[#566952] text-white cursor-not-allowed opacity-55'
      : 'bg-sage text-white hover:bg-[#5C6F59] active:translate-y-px cursor-pointer',
    secondary: isDisabled
      ? 'bg-stone-mid text-ink-soft cursor-not-allowed opacity-55'
      : 'bg-stone-mid text-ink-dark hover:bg-stone-border cursor-pointer',
    ghost: isDisabled
      ? 'text-sage opacity-55 cursor-not-allowed'
      : 'text-sage hover:underline cursor-pointer bg-transparent',
  };

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={`${base} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {loading ? (
        <>
          <Loader2 size={18} className="animate-spin" />
          <span>{loadingText ?? t('common.azioni.caricamento')}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
